import { RestClient } from "./restClient";

export class PatrolTemplateService {
    constructor(options) {
        this._options = options;
        this._restClient = new RestClient();
    }

    getById(id, callback) {
        const url = `/patrols-app/api/patrolTemplates/${id}`;
        this._restClient.exec_get(url, callback);
    }

    getByEventId(eventId, callback) {
        const url = `/patrols-app/api/patrolTemplates/byEventId/${eventId}`;
        this._restClient.exec_get(url, callback);
    }

    create(data, callback) {
        const url = "/patrols-app/api/patrolTemplates";
        const body = JSON.stringify(data);
        this._restClient.exec_post(url, body, callback);
    }

    update(id, data, callback) {
        const url = `/patrols-app/api/patrolTemplates/${id}`;
        const body = JSON.stringify(data);
        this._restClient.exec_put(url, body, callback);
    }

    delete(id, callback) {
        const url = `/patrols-app/api/patrolTemplates/${id}`;
        this._restClient.exec_delete(url, callback);
    }

    addCheckpoint(id, data, callback) {
        const url = `/patrols-app/api/patrolTemplates/${id}/checkpoints`;
        const body = JSON.stringify(data);
        this._restClient.exec_post(url, body, callback);
    }

    updateCheckpoint(id, checkpointId, data, callback) {
        const url = `/patrols-app/api/patrolTemplates/${id}/checkpoints/${checkpointId}`;
        const body = JSON.stringify(data);
        this._restClient.exec_post(url, body, callback);
    }

    deleteCheckpoint(id, checkpointId, callback) {
        const url = `/patrols-app/api/patrolTemplates/${id}/checkpoints/${checkpointId}`;
        this._restClient.exec_delete(url, callback);
    }
}
